import {
  FilterMode,
  MusicalWorkLink_OrderBy,
  MusicalWorkLink,
  SortOrder,
  MusicalWorkLink_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const musicalWorkLinkService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.musicalWorkLinkOne({ id });
    return result.musicalWorkLinkOne as MusicalWorkLink;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: MusicalWorkLink_OrderBy[] | null = null,
    filter: MusicalWorkLink_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: MusicalWorkLink_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.musicalWorkLinkListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.musicalWorkLinkListWithOffset
    ) as MusicalWorkLink[];
    return { list, orderBy };
  },
};
